var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportadorIconSidemenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3176_36252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.89184 0.50293C2.4254 0.50293 1.23779 1.67363 1.23779 3.10263L1.22402 23.8969C1.22402 25.3259 2.41163 26.4966 3.87807 26.4966H19.8953C21.3617 26.4966 22.5631 25.3259 22.5631 23.8969V8.83875C22.5631 8.49324 22.422 8.1645 22.1741 7.91963L14.9521 0.881983C14.7008 0.637108 14.3634 0.50293 14.0089 0.50293H3.89184Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22735 12.4166H26.1189C26.7588 12.4166 27.2486 12.9178 27.2486 13.5009V19.5624C27.2486 20.1454 26.7588 20.6466 26.1189 20.6466H9.22735C8.58749 20.6466 8.09765 20.1454 8.09765 19.5624V13.5009C8.09765 12.9178 8.58748 12.4166 9.22735 12.4166Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9794 9.13137V2.63379L20.315 9.78213H13.6472C13.2789 9.78213 12.9794 9.49029 12.9794 9.13137V9.13137Z",
    stroke: "#231F20",
    strokeWidth: 0.670891,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3176_36252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.1911,
    height: 27,
    fill: "white",
    transform: "translate(0.70742)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportadorIconSidemenu);
export default __webpack_public_path__ + "static/media/importador-icon-sidemenu.523cc211df9b43ca699a4ce0abc13c56.svg";
export { ForwardRef as ReactComponent };